// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-modules-CompetitorAlternatives-style----security-module---main---1ME5O textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-CompetitorAlternatives-style----security-module---wrap---osT8R pageWrap c-black textAlign-center pageWrap-l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CompetitorAlternatives/style/security.module.css
// module id = 1439
// module chunks = 260617349216052